import axios from "axios";
import { getCookie, setCookie } from "../utils/utils";
const jwt = require("jsonwebtoken");

const checkErrorApiService = () => {
  setCookie("oem_auth_token", "", 0);
  localStorage.clear();
  window.location.href = "/phoneNumber";
  return;
};

export const makeAPICall = (config) => {
  const expiry = jwt.decode(getCookie("oem_auth_token"))?.exp;
  let expiry_date = new Date(expiry * 1000);
  let current_date = new Date();
  if (current_date < expiry_date) {
    return new Promise(async (resolve, reject) => {
      try {
        let data = await axios(config);
        resolve(data);
      } catch (e) {
        console.log("YYYerror", e);
        reject(e);
      }
    });
  } else {
    console.log("XXXXXToken expired");
    checkErrorApiService();
  }
};

export const MultipleAPICalls = (configs) => {
  return new Promise(async (resolve, reject) => {
    let calls = [];
    for (let i in configs) {
      calls.push(axios(configs[i]));
    }
    try {
      let data = await axios.all(calls);
      resolve(data);
    } catch (e) {
      reject(e);
    }
  });
};
